import { render, staticRenderFns } from "./ACLRuleForm.vue?vue&type=template&id=faf0b7be&"
import script from "./ACLRuleForm.vue?vue&type=script&lang=js&"
export * from "./ACLRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports